import { ComponentPropsWithRef } from "react";

export const DuplicateIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 12.426C16.5 11.4315 16.8951 10.4776 17.5983 9.77437C18.3016 9.07111 19.2554 8.67603 20.25 8.67603H35.25C36.2446 8.67603 37.1984 9.07111 37.9016 9.77437C38.6049 10.4776 39 11.4315 39 12.426V27.426C39 28.4206 38.6049 29.3744 37.9016 30.0777C37.1984 30.7809 36.2446 31.176 35.25 31.176H20.25C19.2554 31.176 18.3016 30.7809 17.5983 30.0777C16.8951 29.3744 16.5 28.4206 16.5 27.426V12.426ZM20.25 10.551C19.7527 10.551 19.2758 10.7486 18.9242 11.1002C18.5725 11.4518 18.375 11.9287 18.375 12.426V27.426C18.375 27.9233 18.5725 28.4002 18.9242 28.7519C19.2758 29.1035 19.7527 29.301 20.25 29.301H35.25C35.7473 29.301 36.2242 29.1035 36.5758 28.7519C36.9275 28.4002 37.125 27.9233 37.125 27.426V12.426C37.125 11.9287 36.9275 11.4518 36.5758 11.1002C36.2242 10.7486 35.7473 10.551 35.25 10.551H20.25ZM12.75 18.051C12.2527 18.051 11.7758 18.2486 11.4242 18.6002C11.0725 18.9518 10.875 19.4287 10.875 19.926V34.926C10.875 35.4233 11.0725 35.9002 11.4242 36.2519C11.7758 36.6035 12.2527 36.801 12.75 36.801H27.75C28.2473 36.801 28.7242 36.6035 29.0758 36.2519C29.4275 35.9002 29.625 35.4233 29.625 34.926V33.051H31.5V34.926C31.5 35.9206 31.1049 36.8744 30.4016 37.5777C29.6984 38.2809 28.7446 38.676 27.75 38.676H12.75C11.7554 38.676 10.8016 38.2809 10.0983 37.5777C9.39509 36.8744 9 35.9206 9 34.926V19.926C9 18.9315 9.39509 17.9776 10.0983 17.2744C10.8016 16.5711 11.7554 16.176 12.75 16.176H14.625V18.051H12.75Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.6"
    />
  </svg>
);
